import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["mark", "styles"];
import React, { memo } from 'react';
import Full from "./variants/Full.js";
import Mark from "./variants/Mark.js";

/**
 * Planet Logo component
 */
import { jsx as _jsx } from "react/jsx-runtime";
export var Logo = function Logo(_ref) {
  var mark = _ref.mark,
    styles = _ref.styles,
    props = _objectWithoutProperties(_ref, _excluded);
  var renderComponent = function renderComponent() {
    var Component;
    switch (mark) {
      case true:
        Component = Mark;
        break;
      case false:
        Component = Full;
        break;
      default:
        Component = Full;
    }
    return /*#__PURE__*/_jsx(Component, _extends({
      style: _extends({
        height: 100
      }, styles)
    }, props));
  };
  return renderComponent();
};
/**
 * Primary UI component for user interaction
 */
export default /*#__PURE__*/memo(Logo);